export const PRINT_ASSET_TYPES = {
  BACKGROUND: 'BACKGROUND',
  FOREGROUND: 'FOREGROUND',
  LOGO: 'LOGO',
};

export const PRINT_ASSET_SOURCES = {
  USER: 'USER',
  SYSTEM: 'SYSTEM',
};
